"use client";
import { useUser } from "~/modules/user/hooks/useUser";
import { usePathname } from "next/navigation";
import { Routes } from "~/routes";
import { GlobalChatDock } from ".";

// // // //

// Allowed pathnames to show the chat dock
const ALLOWED_PATHNAMES = [Routes.home, Routes.assetScreener];

/**
 * GlobalChatDockLayout
 *
 * A layout component that wraps the GlobalChatDock component and ensures that it is only rendered for logged-in users and on allowed pathnames.
 */
export function GlobalChatDockLayout() {
    const { isLoggedIn } = useUser();
    const pathname = usePathname();

    // If the user is not logged in or the pathname is not allowed, return null
    if (!isLoggedIn || !ALLOWED_PATHNAMES.includes(pathname as Routes)) {
        return null;
    }

    return <GlobalChatDock />;
}
